import React, { Component } from "react"
import Flashcard from "./Flashcard"
import { IFlashcard } from "./types"

interface Props {
    onClose: () => void
    flashcards: IFlashcard[]
    category: string
    flashcardStatus: string
    subcategory?: any
}

interface State {
    currentIndex: number
    showFront: boolean
    flashcards: IFlashcard[]
    isAnimating: boolean
    isAnimatingMiddle: boolean
    isAnimatingBack: boolean
    isAnimatingNew:boolean
}

export default class FlashcardsDeck extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            currentIndex: 0,
            showFront: true,
            flashcards: [],
            isAnimating: false,
            isAnimatingMiddle: false,
            isAnimatingBack: false,
            isAnimatingNew:false
        }
    }

    componentDidMount() {
        let {flashcards, category, flashcardStatus, subcategory} = this.props
        let selectedFlashcards = flashcards.filter(f => f.category == category && f.status === flashcardStatus)

        if (subcategory) {
            selectedFlashcards = selectedFlashcards.filter(fc => fc.subcategory === subcategory)
        }

        this.setState({flashcards: selectedFlashcards})
    }

    onNextCard = () => {
        const { onClose } = this.props;
        const { currentIndex, flashcards } = this.state;
        const nextIndex = currentIndex + 1;
    
        const cardsLeft = flashcards.length - nextIndex;
    
        if (nextIndex > flashcards.length - 1) {
            onClose();
            return;
        }
    
        const isAnimatingNew = cardsLeft > 2;
        const isAnimatingBack = cardsLeft > 1;
        const isAnimatingMiddle = cardsLeft === 1;

        this.setState({
            isAnimatingBack,
            isAnimatingMiddle,
            isAnimating: true,
            isAnimatingNew,
        });
    
        setTimeout(() => {
            this.setState({ isAnimating: false });
        }, 250); // Matches `scrollUpDown` animation duration
    
        setTimeout(() => {
            this.setState({
                isAnimatingBack: cardsLeft <= 1,
                isAnimatingMiddle: cardsLeft === 0,
                isAnimatingNew: false,
                currentIndex: nextIndex,
            });
        }, 250); // Matches `scrollUpDown` animation duration
    };

    render() {
        let {onClose, category} = this.props
        let {flashcards, currentIndex} = this.state
        let nofCards = flashcards.length
        let flashcard = flashcards[currentIndex]
        let flashcardIndexInfo = `Card ${currentIndex + 1} of ${nofCards}`

        if (!flashcard) return null

        let cardsLeft = nofCards - currentIndex - 1;
        let frontCardClasses = `mock-flashcard mock-flashcard--front ${
            this.state.isAnimating ? 'fade-out-in' : ''
        }`
        let newCardClasses = `mock-flashcard mock-flashcard--new ${
            this.state.isAnimatingNew ? 'scroll-move' : cardsLeft <= 2 ? 'scroll-out' : ''
        }`
        let backCardClasses = `mock-flashcard mock-flashcard--back ${
            this.state.isAnimatingBack || (nofCards - currentIndex === 2 || nofCards - currentIndex === 1) ? 'scroll-out' : ''
        }`
        let middleCardClasses = `mock-flashcard mock-flashcard--middle ${
            this.state.isAnimatingNew || nofCards - currentIndex === 1 ? 'scroll-out' : currentIndex > 0 ? 'highlight' : ''
        }`

        return (
            <div className={'flashcards-deck-container ' + category.toLowerCase()}>
                <div className="flashcards-stack">
                    <div className={newCardClasses}></div>
                    <div className={backCardClasses}></div>
                    <div className={middleCardClasses}></div>
                    <div className={frontCardClasses}>
                        <Flashcard
                            flashcard={flashcard}
                            category={category}
                            flashcardIndexInfo={flashcardIndexInfo}
                            onNextCard={this.onNextCard}
                            onClose={onClose}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
